import { Component, Input} from '@angular/core';

/**ToDo Documentazione */
@Component({
  selector: 'app-transport',
  styleUrls: ['./transport.component.scss'],
  templateUrl: './transport.component.html'
})
export class TransportComponent {

  @Input() public days: any;
  @Input() public defaultImage: any;
  @Input() public noImageUrl: any;
  @Input() public replaceShowDescriptionButtonWithNotes: boolean = false;
  @Input() public serviceIcons: any;
  /** Rende la sezione voli (default `true`; `false` per il tab "Trasferimenti" dello split). */
  @Input() public showFlights: boolean = true;
  @Input() public showOptionlServices: any;
  /** Rende la sezione trasferimenti (default `true`; `false` per il tab "Voli" dello split). */
  @Input() public showTransfers: boolean = true;
  @Input() public version: any;
  /** Tenant `enableFlightPassengers`: inoltrato a `app-flights`; assente/false ⇒ invariato. */
  @Input() public enableFlightPassengers: boolean = false;

  /**
   * Un giorno è mostrato se ha contenuto per le sezioni attive: la condizione riprende
   * quella storica del tab "Trasporti" quando entrambe le sezioni sono attive.
   */
  public hasDayContent(day: any): boolean {
    const hasFlights = this.showFlights && day.flights != '';
    const hasTransfers = this.showTransfers && (day.transfers != '' || day.transfersSuggested && day.transfersSuggested.length > 0);
    return hasFlights || hasTransfers;
  }

}
